module.exports = __webpack_public_path__ + "static/media/bronze.8d574544.png";